import config from "config";
import { Dimensions, Platform } from "react-native";
import { getSubscriptionEndpoint } from "screens/common/NotificationConsent/utils";
import { persistToken } from "utils/authentication";
import {
  ReadOTPReceived,
  RemoveSmsListenerIfRegistered
} from "utils/autoOtpRead";
import {
  pushClevertapEvent,
  pushClevertapOnUserLogin
} from "utils/clevertapEvents";
import {
  getGraphQLErrorMessage,
  graphQLClientMutationHelper
} from "utils/graphQL";
import { mLog, mWarn } from "utils/logger";
import { OTP_LOGIN, SEND_OTP, VERIFY_USER_MOBILE } from "./queries";

export const sendOTP = async ({ client, state, onSMSReceived, setError }) => {
  const type = state.user.mobile_verified ? "LOGIN_CODE" : "ACTIVATION_CODE";

  ReadOTPReceived(onSMSReceived);

  const { _, error } = await graphQLClientMutationHelper(client)({
    mutation: SEND_OTP,
    variables: {
      user_id: state.user.id,
      mobile: state.user.mobile,
      type
    }
  });

  const errorMessage = {};
  if (error) {
    RemoveSmsListenerIfRegistered();
    errorMessage.otp = "Error in sending OTP. Please retry";
    setError(errorMessage);
  }
};

export const onSubmitHandler = async ({
  otp,
  client,
  state,
  goNext,
  isNewUser,
  setError,
  authSignIn,
  referralCode
}) => {
  let payload = { userId: state.user.id, otp, clientId: config.API_CLIENT_ID, referralCode };
  const DesktopWidth = Dimensions.get("window").width > 800;

  const registrationSource =
    Platform.OS === "web" && DesktopWidth
      ? "RECRUIT_WEB_CANDIDATE"
      : Platform.OS === "web" && !DesktopWidth
        ? "MOBILE_WEB"
        : "MOBILE_APP";

  // Start of Notification Subscription
  let subscription = null;
  try {
    subscription = await getSubscriptionEndpoint();
  } catch (e) {
    mLog("Got a rejection", e);
  }
  if (subscription) {
    const { expirationTime, ...subscriptionObject } = subscription;
    payload = { ...payload, subscription_object: subscriptionObject };
  }
  // End of Notification Subscription

  const { data: userData, error } = await graphQLClientMutationHelper(client)({
    mutation: state.user.mobile_verified ? OTP_LOGIN : VERIFY_USER_MOBILE,
    variables: payload
  });

  if (error) {
    const newError = {};
    newError.otp = getGraphQLErrorMessage(error);

    pushClevertapEvent("OTP Submit Response", {
      Error: newError.otp,
      Current_Page: "New loginRegistration",
      Page_Modal: "OTP Verification",
      Test_Case: state.variant,
      Status: "F",
      User_Type: isNewUser ? "New User" : "Existing User",
      Platform: registrationSource || "NA"
    });
    mWarn("error", error);
    setError(newError);
    return;
  }

  pushClevertapEvent("OTP Submit Response", {
    Current_Page: "New loginRegistration",
    Page_Modal: "OTP Verification",
    Test_Case: state.variant,
    Status: "S",
    User_Type: isNewUser ? "New User" : "Existing User",
    Platform: registrationSource || "NA"
  });

  pushClevertapOnUserLogin({
    Identity: userData.id,
    Phone: `+91${userData.mobile}`
  });

  persistToken(userData.access_token);

  goNext({ user: { ...userData, mobile: state.user.mobile }, authSignIn });
};
